/**
 * Exhaustiveness guard for switches over a union.
 *
 * Put it in the `default` branch: the moment a union gains a member, the
 * argument stops being `never` and the call no longer compiles.
 */
export function assertNever(value: never): never {
  throw new Error(`Unhandled case: ${String(value)}`);
}
